"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormatterType = void 0;
const config_1 = require("../config/config");
const TimeUtil_1 = require("./TimeUtil");
var DateFormatterType;
(function (DateFormatterType) {
    DateFormatterType["DateFormat"] = "DateFormat";
    DateFormatterType["DateTimeFormat"] = "DateTimeFormat";
    DateFormatterType["TimeFormat"] = "TimeFormat";
})(DateFormatterType || (exports.DateFormatterType = DateFormatterType = {}));
class DateTimeFormatter {
    constructor() {
        this.dateFormatterTypeToString = (key) => DateFormatterType[key];
        this.dateFormatterTypeFromString = (key) => {
            switch (key) {
                case `DateFormat`:
                    return DateFormatterType.DateFormat;
                case `DateTimeFormat`:
                    return DateFormatterType.DateTimeFormat;
                case `TimeFormat`:
                    return DateFormatterType.TimeFormat;
                default:
                    return undefined;
            }
        };
        this.getDateFormat = (key) => {
            var _a;
            switch ((_a = config_1.react_core_config.internalConfig.dateFormatter) === null || _a === void 0 ? void 0 : _a[key]) {
                case DateFormatterType.DateFormat:
                    return config_1.react_core_config.defaultDateFormat();
                case DateFormatterType.TimeFormat:
                    return config_1.react_core_config.defaultTimeFormat();
                case DateFormatterType.DateTimeFormat:
                    return config_1.react_core_config.defaultDateTimeFormat();
                case undefined:
                default:
                    return config_1.react_core_config.defaultDateTimeFormatFallback();
            }
        };
        this.getFormattedDateFromDateString = (key, date) => (0, TimeUtil_1.formatDateString)(date, this.getDateFormat(key));
        this.getFormattedDateFromMoment = (key, date) => (0, TimeUtil_1.formatMomentDate)(date, this.getDateFormat(key));
        this.getFormattedDateFromTimeStamp = (key, timestamp) => (0, TimeUtil_1.formatTimeStamp)(timestamp, this.getDateFormat(key));
        this.getFormattedDateFromCurrentTime = (key) => (0, TimeUtil_1.formatCurrentTime)(this.getDateFormat(key));
    }
}
const dateTimeFormatter = new DateTimeFormatter();
exports.default = dateTimeFormatter;
//# sourceMappingURL=DateTimeFormatter.js.map